import { editingLineItemType, portalLineItemType, shipToType } from './orderTypes'
import {
  flattenLineItems as flattenGroupedLines,
  nestLineItems,
  portalKitAccessors,
  unflattenLineItems as unflattenGroupedLines,
} from '../../../helper'

export function lineKey(item: { Kit?: string | null; Number?: number | null }): string {
  return `${item.Kit ?? ''}-${item.Number ?? -2}`
}

export function toShipTo(source: Partial<shipToType>): shipToType {
  return {
    ShipToAttention: source.ShipToAttention ?? null,
    ShipToCompany: source.ShipToCompany ?? null,
    ShipToAddress1: source.ShipToAddress1 ?? null,
    ShipToAddress2: source.ShipToAddress2 ?? null,
    ShipToAddressCity: source.ShipToAddressCity ?? null,
    ShipToAddressState: source.ShipToAddressState ?? null,
    ShipToAddressZip: source.ShipToAddressZip ?? null,
    ShipToAddressCountry: source.ShipToAddressCountry ?? null,
    ReceiverContactName: source.ReceiverContactName ?? null,
    ReceiverContactEmail: source.ReceiverContactEmail ?? null,
    ReceiverContactPhone: source.ReceiverContactPhone ?? null,
  }
}

export function shipTosEqual(a: Partial<shipToType>, b: Partial<shipToType>) {
  return JSON.stringify(toShipTo(a)) === JSON.stringify(toShipTo(b))
}

export type BulkShippingAddressSource = shipToType & { id: number }

export function bulkApplyShippingAddress(
  lines: editingLineItemType[],
  address: BulkShippingAddressSource,
): editingLineItemType[] {
  return lines.map(item => {
    if (!item.selected) return item
    const base = {
      ...item,
      ShipToAttention: address.ShipToAttention,
      ShipToCompany: address.ShipToCompany,
      ShipToAddress1: address.ShipToAddress1,
      ShipToAddress2: address.ShipToAddress2,
      ShipToAddressCity: address.ShipToAddressCity,
      ShipToAddressState: address.ShipToAddressState,
      ShipToAddressZip: address.ShipToAddressZip,
      ShipToAddressCountry: address.ShipToAddressCountry,
      addressId: address.id,
    }
    if (address.ReceiverContactName) {
      return {
        ...base,
        ReceiverContactName: address.ReceiverContactName,
        ReceiverContactEmail: address.ReceiverContactEmail ?? null,
        ReceiverContactPhone: address.ReceiverContactPhone ?? null,
      }
    }
    return base
  })
}

export const nestKitLineItems = (items: portalLineItemType[]) => nestLineItems(items, portalKitAccessors)

export const flattenLineItems = (items: portalLineItemType[]) => flattenGroupedLines(items)

export const unflattenLineItems = (flat: portalLineItemType[]) => unflattenGroupedLines(flat, portalKitAccessors)

export function stripEditingFields(items: editingLineItemType[]): portalLineItemType[] {
  return items.map(({ addressId: _a, selected: _s, ...rest }) => rest as portalLineItemType)
}
